const state = {
  queue: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/LoadingQueue/state.js